// extracted by mini-css-extract-plugin
module.exports = {"jargon":"jargon-module--jargon--3sqQJ","title":"jargon-module--title--3rwVt","jargonCards":"jargon-module--jargonCards--2qyma","jargonCard":"jargon-module--jargonCard--3XnCt"};